import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supplier/$supplierId/settings/locations")({
  component: lazyRouteComponent(() => import("./+Locations")),
  head: () => ({
    meta: seo({ title: "Locations" }),
  }),
});
